import {swalConfirmFire} from "../../plugins/sweet-alert/sweet-alert-default";

var Upload = function (file, progressBarId) {
    this.file = file;
    this.progressBarId = progressBarId;
};

Upload.prototype.getProgressBarId = function () {
    return this.progressBarId;
};
Upload.prototype.getType = function () {
    return this.file.type;
};
Upload.prototype.getSize = function () {
    return this.file.size;
};
Upload.prototype.getName = function () {
    return this.file.name;
};
Upload.prototype.doUpload = function (componentData) {
    var that = this;
    var formData = new FormData();
    const fileName = this.getName();

    let inputName = 'file';
    if (that.file.type.match('video.*')) {
        inputName = 'video';
    }

    // add assoc key values, this will be posts values
    formData.append(inputName, this.file, fileName);
    formData.append("upload_file", true);

    $.ajax({
        type: "POST",
        headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
        url: componentData.cloudUploadUrl,
        xhr: function () {
            var myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) {
                myXhr.upload.progressBarId = that.getProgressBarId();
                myXhr.upload.addEventListener('progress', that.progressHandling, true);
            }
            return myXhr;
        },
        success: function (data) {
            $("#" + componentData.cloudDivId).find('.cloud-component-image').remove();

            const cloudFileUrlSmall = componentData.cloudShowSmallImgRoute + '/' + data.id + '/' + data.name;
            $("#" + componentData.cloudDivId).append('<img src="' + cloudFileUrlSmall + '" class="cloud-component-image">');
            $("#" + componentData.cloudInputId).val(data.id);

            $("." + componentData.cloudInputNameId + " input").val(fileName);

            if ($("#" + componentData.cloudInputId).hasClass('copyToAdditionalData')) {
                const $cloudImageDiv = $(document.getElementById(componentData.cloudDivId));
                const $cloudComponentPopup = $cloudImageDiv.closest('.survey-item')
                    .find('.row:nth-child(2)')
                    .find('.cloud-component-popup');
                const cloudDivId = $cloudComponentPopup.data('cloud-div-id');
                const cloudFileInputId = $cloudComponentPopup.data('cloud-input-id');
                const cloudFileInputNameId = $cloudComponentPopup.data('cloud-input-name-id');
                const cloudComponentId = $cloudComponentPopup.data('cloud-component-id');

                $(document.getElementById(cloudDivId))
                    .html('')
                    .append('<img src="' + cloudFileUrlSmall + '" class="cloud-component-image">');

                const $context = $cloudImageDiv.closest('.tab-pane');
                $context.find("#" + cloudFileInputId).attr('value', data.id);
                $context.find("." + cloudFileInputNameId + " input").val(data.original_name.split('.').slice(0, -1).join('.'));

                $context.find(".cloud-component-popup." + cloudComponentId).addClass('hide');
                $context.find(".cloud-component-upload." + cloudComponentId).addClass('hide');
                $context.find(".cloud-component-remove." + cloudComponentId).removeClass('hide');
                $context.find(".cloud-component-change-video-image." + cloudComponentId).removeClass('hide');
                $context.find('.stimuliAdditionalData').removeClass('hide');
            }

            $("." + componentData.cloudBrandNameInputId).val(that.getName().split('.').slice(0, -1).join('.'));

            $(".cloud-component-popup." + componentData.cloudComponentId).addClass('hide');
            $(".cloud-component-upload." + componentData.cloudComponentId).addClass('hide');
            $(".cloud-component-remove." + componentData.cloudComponentId).removeClass('hide');
            $(".cloud-component-change-video-image." + componentData.cloudComponentId).removeClass('hide');
        },
        error: function (xhr) {
            if (xhr.responseJSON.errors.file !== undefined) {
                xhr.responseJSON.errors.file.forEach(function (error) {
                    $(".cloud-component-upload." + componentData.cloudComponentId)
                        .closest('.cloud-files-component')
                        .find('.file-upload-errors').html('');
                    $(".cloud-component-upload." + componentData.cloudComponentId)
                        .closest('.cloud-files-component')
                        .find('.file-upload-errors')
                        .append('<div class="invalid-feedback d-block">' + error + '</div>');
                });
            }
            if (xhr.responseJSON.errors.video !== undefined) {
                xhr.responseJSON.errors.video.forEach(function (error) {
                    $(".cloud-component-upload." + componentData.cloudComponentId)
                        .closest('.cloud-files-component')
                        .find('.file-upload-errors').html('');
                    $(".cloud-component-upload." + componentData.cloudComponentId)
                        .closest('.cloud-files-component')
                        .find('.file-upload-errors')
                        .append('<div class="invalid-feedback d-block">' + error + '</div>');
                });
            }
            $("#" + that.progressBarId).parent().remove();
        },
        complete: function () {
            $("#" + that.progressBarId).parent().remove();
        },
        async: true,
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        timeout: 60000
    });
}

Upload.prototype.progressHandling = function (event) {
    var percent = 0;
    var position = event.loaded || event.position;
    var total = event.total;
    if (event.lengthComputable) {
        percent = Math.ceil(position / total * 100);
    }
    // update progressbars classes so it fits your code
    $(document).find('#' + event.currentTarget.progressBarId).css("width", +percent + "%");
};

export function attachCloudFileUpload($context) {
    if (!$context.length) {
        return;
    }

    $context.on('change', '.cloud-component-upload input[type=file]', async function (e) {
        const allFiles = $(this)[0].files;
        const thisContext = $(this);
        for (let index = 0; index < allFiles.length; index++) {
            await makeUploadAjaxRequest(thisContext, allFiles[index], index);
        }
    });
}

async function makeUploadAjaxRequest(input, file, index) {
    let data = null;
    const $element = input;

    if (index > 0) {
        // przejdź po stimuli i sprawdź:
        const $allStimulus = $('body').find('.tab-pane.active .list-objects div.col-md-6');
        $allStimulus.each(function (index, stimuli) {
            // czy stimuli ma wybrany obrazek
            if ($(stimuli).find('.cloud-component-upload').hasClass('hide')) {
                // jeśli tak to pomiń i sprawdź następny
                return;
            }

            // jeśli nie to dodaj obrazek do niego
            $(stimuli).find('.cloud-component-upload').addClass('hide')
            data = $(stimuli).find('.cloud-component-upload').data();
            return false;
        });
    } else {
        // jeśli to pierwszy obrazek to przypisz go do stimuli gdzie było kliknięcie w button
        input.closest('.cloud-component-upload').addClass('hide')
        data = input.closest('.cloud-component-upload').data();
    }

    if (null === data) {
        // jeśli data jest puste, to dodaj nowe stimuli i przypisz do niego obrazek
        $('body').find('.tab-pane.active .objects-quantity').val(function (i, oldVal) {
            return ++oldVal;
        }).trigger('change').after(function () {
            $('body').find('.tab-pane.active .list-objects div.col-md-6:last-child .cloud-component-upload').addClass('hide')
            data = $('body').find('.tab-pane.active .list-objects div.col-md-6:last-child .cloud-component-upload').data();
        });
    }

    const progressBarId = 'progressbar-' + Date.now();
    await verifyNameRequest(file, progressBarId, $element, data);
}

async function verifyNameRequest(file, progressBarId, $element, data) {
    try {
        await $.ajax({
            method: 'GET',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            url: '/panel/cloud-files/verify-name',
            async: true,
            data: {fileName: file.name},
        }).then(async function (verificationResult) {
            async function uploadFile() {
                var upload = new Upload(file, progressBarId);

                // add progress bar inside label under button
                $element.parent().parent().append('<div class="progress" style="width: 100%">' +
                    '<div id="' + progressBarId + '" class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>' +
                    '</div>');

                // execute upload
                await upload.doUpload(data);
            }

            if (verificationResult.isUnique) {
                await uploadFile();
                return;
            }

            await swalConfirmFire({
                title: 'The file name "' + file.name + '" has already been used',
                text: 'Are you sure you want to upload it?',
                icon: 'question'
            })
                .then(result => {
                    if (!result.isConfirmed) {
                        // clear file input
                        $element.replaceWith($element.val('').clone(true));
                        return;
                    }

                    uploadFile();
                })
        });
    } catch (error) {
        console.log(error);
    }
}
